import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=6cc372c0&"
import script from "./SessionsList.vue?vue&type=script&lang=js&"
export * from "./SessionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports